import React from "react";
import { Instagram, MessageCircle } from "lucide-react";
import Logo from "./Logo";
import { NAV, INSTAGRAM_URL, waLink, scrollToId } from "../lib/site";

const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#020204]">
    <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <Logo />
          <p className="mt-5 max-w-xs text-sm font-light leading-relaxed text-white/45">
            Tecnologia que transforma negócios.
          </p>
        </div>
        <nav aria-label="Links do rodapé">
          <span className="text-[11px] font-semibold tracking-[0.3em] text-white/40">
            NAVEGAÇÃO
          </span>
          <ul className="mt-5 space-y-3">
            {NAV.map((item) => (
              <li key={item.id}>
                <button
                  type="button"
                  onClick={() => scrollToId(item.id)}
                  data-testid={`footer-link-${item.id}`}
                  className="text-sm font-light text-white/55 transition-colors duration-300 hover:text-[#00E5FF]"
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <span className="text-[11px] font-semibold tracking-[0.3em] text-white/40">
            REDES
          </span>
          <div className="mt-5 flex gap-3">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram-button"
              aria-label="Instagram da EDALIX"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-white/5 text-white/70 transition-[border-color,color,transform] duration-300 hover:scale-105 hover:border-[#00E5FF]/60 hover:text-[#00E5FF]"
            >
              <Instagram className="h-4.5 w-4.5" style={{ width: 18, height: 18 }} />
            </a>
            <a
              href={waLink("Olá! Vim pelo site da EDALIX e quero conversar.")}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-button"
              aria-label="WhatsApp da EDALIX"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-white/5 text-white/70 transition-[border-color,color,transform] duration-300 hover:scale-105 hover:border-[#00E5FF]/60 hover:text-[#00E5FF]"
            >
              <MessageCircle style={{ width: 18, height: 18 }} />
            </a>
          </div>
        </div>
      </div>
      <div className="mt-14 border-t border-white/10 pt-7">
        <p className="text-xs font-light text-white/35">
          © 2026 EDALIX Tecnologia. Todos os direitos reservados.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
